function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3849 15.17L20.3269 0L4.26693 15.17C1.85057 17.2143 0.331887 20.1243 0.036829 23.2756C-0.258229 26.4269 0.693862 29.5683 2.68875 32.0256C4.68363 34.4829 7.56234 36.0602 10.707 36.4191C13.8517 36.7779 17.0117 35.8897 19.5089 33.945C18.9152 36.2134 17.7189 38.279 16.0469 39.923L13.7539 42.177L14.5609 41.953C18.3325 40.9076 22.3174 40.9076 26.089 41.953L26.8959 42.177L24.6029 39.923C22.9309 38.279 21.7347 36.2134 21.141 33.945C23.6372 35.9003 26.8015 36.797 29.9524 36.4421C33.1034 36.0871 35.9889 34.5089 37.9876 32.0473C39.9863 29.5856 40.9382 26.4375 40.6385 23.2808C40.3387 20.1241 38.8112 17.2115 36.3849 15.17Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40.654,
  height: 42.177,
  fill: "white"
})));

var SvgSpadesSmall = function SvgSpadesSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpadesSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spades-small.3e524a03.svg";
export { ForwardRef as ReactComponent };